<hlm-sheet
  [side]="side()"
  [overlayClass]="overlayClass()"
  [state]="state()"
  [hasBackdrop]="hasBackdrop()"
  [closeOnBackdropClick]="closeOnBackdropClick()"
  [closeOnOutsidePointerEvents]="closeOnOutsidePointerEvents()"
  [autoFocus]="$any(autoFocus())"
  [aria-label]="ariaLabelledBy() ? null : ariaLabel()"
  [aria-labelledby]="ariaLabelledBy()"
  (closed)="closed.emit($event)"
>
  <hlm-sheet-content *hlmSheetPortal [showCloseButton]="showCloseButton()" [class]="contentClass()">
    <ng-content />
  </hlm-sheet-content>
</hlm-sheet>
